import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "lenis";

export const Animations = {
  init: function () {
    this.cacheSelectors();
    this.setVendors();
    this.bindEvents();
  },

  cacheSelectors: function () {
    this.lenis = null;
    this.navbar = document.getElementById("navbar");
    this.navbarDefaultClasses = this.navbar.getAttribute("class");
    this.navbarActiveBackground = "";
    this.sections = document.querySelectorAll('[class*="background--"]');
    this.currentStep = 0;

    // home animations
    const scrollableDiv = document.getElementById("creativity_scroll")
      ? document.getElementById("creativity_scroll")
      : null;
    const boxCreativity = document.querySelectorAll(
      "#creativity_scroll .creativity__desktop .images .box"
    );

    gsap.registerPlugin(ScrollTrigger);

    if (scrollableDiv) {
      // scrollableDiv.addEventListener('wheel', this.helper.funcDebounce(this.Events.scrollCreativity.bind(this), 500), { passive: false });

      const totalBoxes = boxCreativity.length;
      

      boxCreativity.forEach((box, index) => {
        ScrollTrigger.create({
          trigger: "#creativity_scroll",
          start: "top center", // Início do trigger
          end: "bottom", // Final do trigger
          scrub: true,
          markers: false,
          onUpdate: (self) => {
            const progress = self.progress;
            const index = Math.floor(progress * totalBoxes * 2);
            updateActiveBox(index);
          },
        });
      });

      function updateActiveBox(activeIndex) {
        var listCreativity = document.querySelectorAll(".creativity__desktop .list li");
        const self = Animations;
        if (!(activeIndex > 3)) {
          boxCreativity.forEach((box, index) => {
            if (index === activeIndex) {
              self.Events.changeLine(activeIndex);
              listCreativity[activeIndex].classList.add("active");
              box.classList.add("active");
            } else {
              listCreativity[index].classList.remove("active");
              box.classList.remove("active");
            }
          });
        }
      }
    }
  },
  setVendors: function () {
    gsap.registerPlugin(ScrollTrigger);

    this.lenis = new Lenis({
      orientation: "vertical",
      wheelMultiplier: 1,
      lerp: 0.075,
      duration: 0.8,
      easing: function (t) {
        return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
      },
    });
    requestAnimationFrame(this.Methods.raf);
  },
  bindEvents: function () {
    const self = this;
    this.sections.forEach((section) => {
      ScrollTrigger.create({
        trigger: section,
        start: "top top",
        end: "bottom top",
        onEnter: () => self.changeNavbarColor(section),
        onEnterBack: () => self.changeNavbarColor(section),
      });
    });

    window.addEventListener("scroll", function () {
      if (window.scrollY > 0) {
        self.navbar.classList.add("active");
      } else {
        self.navbar.classList = self.navbarDefaultClasses;
      }
    });
  },
  changeNavbarColor: function (section) {
    const self = this;

    const exists = self.navbarActiveBackground;
    if (exists) {
      self.navbar.classList.remove(exists);
    }
  },
  Methods: {
    raf: function (time) {
      const self = Animations;
      self.lenis.raf(time);
      requestAnimationFrame(self.Methods.raf);
    },
  },
  Events: {
    changeLine: (step) => {
      let calcHeight = 55 + 15 * step;
      document.querySelector(".marc .line").style.height = calcHeight + "%";
    },
  },
  helper: {
    funcDebounce: (func, wait) => {
      let timeout;
      return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    },
  },
};
